import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 15 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.79167 5.64826C0.73611 5.49858 0.73611 5.33393 0.79167 5.18426C1.3328 3.87216 2.25135 2.75028 3.43085 1.96085C4.61035 1.17143 5.9977 0.75 7.417 0.75C8.83631 0.75 10.2237 1.17143 11.4032 1.96085C12.5827 2.75028 13.5012 3.87216 14.0423 5.18426C14.0979 5.33393 14.0979 5.49858 14.0423 5.64826C13.5012 6.96035 12.5827 8.08223 11.4032 8.87166C10.2237 9.66108 8.83631 10.0825 7.417 10.0825C5.9977 10.0825 4.61035 9.66108 3.43085 8.87166C2.25135 8.08223 1.3328 6.96035 0.79167 5.64826Z",
		stroke: "#292929",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.417 7.41626C8.52157 7.41626 9.417 6.52083 9.417 5.41626C9.417 4.31169 8.52157 3.41626 7.417 3.41626C6.31243 3.41626 5.417 4.31169 5.417 5.41626C5.417 6.52083 6.31243 7.41626 7.417 7.41626Z",
		stroke: "#292929",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEye;
